import { render, staticRenderFns } from "./CustomerBasicInfosSection.vue?vue&type=template&id=b7603692&scoped=true&"
import script from "./CustomerBasicInfosSection.vue?vue&type=script&lang=js&"
export * from "./CustomerBasicInfosSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerBasicInfosSection.vue?vue&type=style&index=0&id=b7603692&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7603692",
  null
  
)

export default component.exports